/* eslint-disable no-bitwise */
export { DMS_MODULE } from '../constants';
export const NAME = 'ManagementSestavy';
export const API_NAME = 'Management';
export const CRUMB_LABEL_KEY = 'StandRepManager';

export enum RozsahDate {
	casDnes,
	casVcera,
	casTentoMesic,
	casMinulyMesic,
	casTentoRok,
	casMinulyRok,
	casMinulyKvart,
	casLibObdobi,
}

export enum AccessSestavyFlagEnum {
	NONE = 0,
	DODAVATEL = 1,
	NDPOHYB = 2,
	NDSKLAD = 4,
	P_NDPOHYB = 8,
	PRACOVNIK = 16,
	S_ZAKAZKADRUH = 32,
	SKLAD = 64,
	ZAKAZNIK = 128,
	ZAKAZKA = 256,
	PROVOZOVNA = 512,
	DOKLAD = 1024,
	DOKLADPOLOZ = 2048,
	VYROBEKND = 4096
}

const permission = {
	vyhodnoceniPouzitychPaketu: <const>AccessSestavyFlagEnum.PROVOZOVNA && AccessSestavyFlagEnum.DOKLAD
		&& AccessSestavyFlagEnum.DOKLADPOLOZ,
	informaceoServisuDleNS: <const>AccessSestavyFlagEnum.PROVOZOVNA && AccessSestavyFlagEnum.PRACOVNIK && AccessSestavyFlagEnum.DOKLAD
		&& AccessSestavyFlagEnum.DOKLADPOLOZ,
	trzbyNORApodleKoduMarketu: <const>AccessSestavyFlagEnum.PROVOZOVNA && AccessSestavyFlagEnum.DOKLAD
		&& AccessSestavyFlagEnum.DOKLADPOLOZ,
	obratySkladuDlePracovnika: <const>AccessSestavyFlagEnum.NDPOHYB && AccessSestavyFlagEnum.NDSKLAD
		&& AccessSestavyFlagEnum.VYROBEKND,
	obratyDilnyDlePracovnika: <const>AccessSestavyFlagEnum.DOKLAD && AccessSestavyFlagEnum.DOKLADPOLOZ,
};

export const buttons = <const>[
	{
		labelKey: 'VyhodnoceniMA',
		routeName: 'VyhodnoceniPouzitychPaketu',
		api: 'GetVyhodnoceniPouzitychPaketu',
		permission: permission.vyhodnoceniPouzitychPaketu,
	},
	{
		labelKey: 'cmdInfoServis',
		routeName: 'InformaceoServisuDleNS',
		api: 'GetInformaceoServisuDleNS',
		permission: permission.informaceoServisuDleNS,
	},
	{
		labelKey: 'cmdNoraMarket',
		routeName: 'TrzbyNORApodleKoduMarketu',
		api: 'GetTrzbyNORApodleKoduMarketu',
		permission: permission.trzbyNORApodleKoduMarketu,
	},
	{
		labelKey: 'cmdObratySklDleSkladniku',
		routeName: 'ObratySkladuDlePracovnika',
		api: 'GetObratySkladuDlePracovnika_Skladnici',
		permission: permission.obratySkladuDlePracovnika,
	},
	{
		labelKey: 'cmdObratyDlePrejimTech',
		routeName: 'ObratyDilnyDlePracovnika',
		api: 'GetObratyDilnyDlePracovnika',
		permission: permission.obratyDilnyDlePracovnika,
	},
];

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
